// @api
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @constants
const actionTypes = require('constants/actionTypes');

const getOpenYoungProfilesInProgress = () =>({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_REQUEST
});

const getOpenYoungProfilesSuccess = response =>({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_SUCCESS,
    payload: {
        profiles: response
    }
});

const getOpenYoungProfilesFailure = error =>({
    type: actionTypes.OPEN_YOUNG_GET_PROFILES_FAILURE,
    payload: { error }
});

const getOpenYoungProfiles = () => (dispatch) => {
    const requestData = {
        header: {
            version: 1
        },
        query: {}
    };

    dispatch(getOpenYoungProfilesInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('openYoungGetProfiles'), requestData)
        .then(response => {
            dispatch(getOpenYoungProfilesSuccess(response));
            return response;
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungProfilesFailure(response.error.description));
                return response;
            } else {
                throw response;
            }
        });
};

module.exports = {
    getOpenYoungProfiles,
};
